import { render, staticRenderFns } from "./DefDocsIndex.vue?vue&type=template&id=53a0ee7c&"
import script from "./DefDocsIndex.vue?vue&type=script&lang=js&"
export * from "./DefDocsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DefDocsIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports